import request from './request';

export default {
	downloadOAuthUrl(shop) {
		return request.get('/apps/shopify/auth-url', shop);
	},

	login(body) {
		return request.post('/auth/shopify', body);
	}
};



// WEBPACK FOOTER //
// ./src/helpers/chated-client/shopify.js